import {SquadDiskUsersApi} from "../../../../apis/squaddisk-users/SquadDiskUsersApi";

export const LOCAL_KEYS: string[] = ["barButtons", "home", "showScrollbar", "tvMode", "tvModePromptDismissed"];

export type LocalPreferenceKey = typeof LOCAL_KEYS[number];

export const loadLocalPreferences = () => {
    const map: Record<string, any> = {};
    for (const key of LOCAL_KEYS) {
        try {
            const raw = localStorage.getItem(`userPreference_${key}`);
            if (raw) map[key] = JSON.parse(raw);
        } catch {
        }
    }
    return map;
};

export const saveLocalPreference = (key: LocalPreferenceKey, value: any) => {
    localStorage.setItem(`userPreference_${key}`, JSON.stringify(value));
};

export const fetchRemotePreferences = async () => {
    const res = await SquadDiskUsersApi.getUserPreferences().catch(() => ({preferences: {}}));
    return res.preferences ?? {};
};

export const updateRemotePreference = async (key: string, value: any) => {
    return SquadDiskUsersApi.updateUserPreference({key, value});
};
